module.exports = __webpack_public_path__ + "static/media/warmCool.8da4c922.png";